// properties / attributes that you want to update
const attributeNameMap = {
  collectionHandle: 'collection-handle',
  isGiftCollection: 'is-gift-collection',
  hideBadges: 'hide-badges'
};

export async function defineExtendedNostoCard() {
    await customElements.whenDefined('nosto-dynamic-card');
    const NostoDynamicCard = customElements.get("nosto-dynamic-card");
    
    class ExtendedNostoCard extends NostoDynamicCard {
        static get observedAttributes() {
            return [...super.observedAttributes, "attr-extend"];
        }
    
        async attributeChangedCallback(name, oldVal, newVal) {
            await super.attributeChangedCallback(name, oldVal, newVal);
            this.applyAttrExtend();
        }
    
        async connectedCallback() {
            await super.connectedCallback();
            this.applyAttrExtend();
            this.observeInnerChanges();
        }
    
        applyAttrExtend() {
            const inner = this.querySelector("nova-product-card");
            if (!inner) return;
    
            const attr = this.getAttribute("attr-extend");
            if (!attr) return;
    
            let newAttrs;
            try {
                newAttrs = JSON.parse(attr);
                if (!Array.isArray(newAttrs)) {
                    newAttrs = [newAttrs];
                }
            } catch (err) {
                console.error("Invalid JSON in attr-extend:", err);
                return;
            }
    
            for (const item of newAttrs) {
                if (!item || typeof item !== "object") continue;
    
                for (const [key, value] of Object.entries(item)) {
                    const attrName = attributeNameMap[key] || key;
                    if (typeof value === "object") {
                        inner.setAttribute(attrName, JSON.stringify(value));
                    } else {
                        inner.setAttribute(attrName, value);
                    }
                }
            }
        }
    
        observeInnerChanges() {
            if (this._observer) return;
    
            this._observer = new MutationObserver((mutations) => {
                for (const m of mutations) {
                    if (m.type === "childList") {
                        this.applyAttrExtend();
                    }
                }
            });
    
            this._observer.observe(this, { childList: true, subtree: true });
        }
    
        disconnectedCallback() {
            if (super.disconnectedCallback) super.disconnectedCallback();
            if (this._observer) {
                this._observer.disconnect();
                this._observer = null;
            }
        }
    }

    if (!customElements.get("extended-nosto-card")) {
        customElements.define("extended-nosto-card", ExtendedNostoCard);
    }

    return ExtendedNostoCard;
}